// Stored quotes are decimals (0.0065). The Bonds table shows spread in bp and yield in percent,
// and the number filter matches String(cellValue), so row values have to be in those same units.

export const toSpreadBp = (spread: number): number => Math.round(spread * 10000);

export const toYieldPct = (ytm: number): number => Math.round(ytm * 10000) / 100;
